import React from 'react';
import PropTypes from 'prop-types';
import { IconRenderer, Link } from '..';
import classNames from 'classnames';
import Festiveborder from '../../assets/festiveborder.svg';
import Star from '../../assets/star.svg';
import { selectCampaignBorder, selectCampaignIcon } from '@/store';

const FestiveButton = ({ link, className, children, ...props }) => {
  return (
    <Link link={link} className={classNames('group festive-button h-10 flex items-center', className)} {...props}>
      <div className="w-2.5 flex flex-col overflow-hidden">
        <IconRenderer
          selector={selectCampaignBorder}
          fallback={<Festiveborder />}
          className="festive-border stroke-primary fill-transparent group-hover:fill-primary transition-colors duration-500"
        />
        <IconRenderer
          selector={selectCampaignBorder}
          fallback={<Festiveborder />}
          className="festive-border stroke-primary fill-transparent group-hover:fill-primary scale-x-[-1] rotate-180 transition-colors duration-500"
        />
      </div>

      <div className="festive-btn-content text-tag-m font-cera text-primary group-hover:text-highlight-sunshineYellow border-y-[0.1em] border-y-primary not-italic font-normal leading-[22px] h-full flex justify-center items-center bg-transparent group-hover:bg-primary transition-colors duration-500">
        <IconRenderer
          selector={selectCampaignIcon}
          fallback={<Star />}
          className="festive-icon fill-primary group-hover:fill-highlight-sunshineYellow transition-colors duration-500 mr-0.5"
        />
        {children || link?.text}
      </div>
      <div className="w-3 flex flex-col items-end overflow-hidden">
        <IconRenderer
          selector={selectCampaignBorder}
          fallback={<Festiveborder />}
          className="festive-border stroke-primary fill-transparent group-hover:fill-primary scale-x-[-1] transition-colors duration-500"
        />
        <IconRenderer
          selector={selectCampaignBorder}
          fallback={<Festiveborder />}
          className="festive-border stroke-primary fill-transparent group-hover:fill-primary scale-y-[-1] scale-x-[-1] transition-colors duration-500"
        />
      </div>
    </Link>
  );
};

FestiveButton.propTypes = {
  link: PropTypes.object,
};

export default FestiveButton;
